import * as React from 'react';
import { useContext } from 'react';
import { IAction, IState } from './disputes-interfaces';
import { disputesReducer } from './disputes-reducer';


type disputesProviderProps = { children: React.ReactElement }

const disputesStateContext = React.createContext<{ disputesContextState: IState; dispatch: React.Dispatch<IAction> } | undefined>(undefined);

export const initialState = {
	disputes: null,
	isDisputesLoading: false,
	isDisputesExportLoading: false,
	disputeDetails: null,
	isDisputeDetailsLoading: true,
	query: '',
	sort: 'desc',
	pageNumber: 0,
	pageSize: 10,
	from: null,
	to: null,
	createdFrom: null,
	createdTo: null,
	disputeDetailsCreatedFrom: null,
	disputeDetailsCreatedTo: null,
	requestFrom: null,
	requestTo: null,
	timezone: 'UTC',
	sorting: [],
	totalItemCount: 0,
	managementSystem: null,
	cardBrands: null,
	selectedProviderName: [],
	selectedCardBrand: [],
	selectedDisputeType: [],
	isWebhook: '',
	isFileImported: '',
	isManualInserted: '',
	isDisputeMatchLoading: false,
	isKountAlertLoading: false,
	disputeDetailsLists: null,
	isArchivatingDisputeLoading: false,
	disputeQueues: [],
	isDisputeQueuesLoading: true,
	isProviderName: false,
	disputeQueueTotalItemCount: 0,
	disputeQueueTimezone: 'UTC',
	kountStatusCodes: {},
	reportProvidersList: [],
	isReportProviderListLoading: false,
};

const DisputesProvider = ({ children }: disputesProviderProps): JSX.Element => {
	const [disputesContextState, dispatch] = React.useReducer(disputesReducer, initialState);
	const value = { disputesContextState, dispatch };
	return (
		<disputesStateContext.Provider value={value}>
			{children}
		</disputesStateContext.Provider>
	);
};

const useDisputesContext = (): { disputesContextState: IState; dispatch: React.Dispatch<IAction> } => {
	const context = useContext(disputesStateContext);
	if (context === undefined) {
		throw new Error('useDisputesContext must be used within a DisputesProvider');
	}
	return context;
};

export { DisputesProvider, useDisputesContext };
